import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from '../../../../../models/base/base-component';
import {Tabbable} from '../../../../../models/protocols/tabbable';
import {ArchivedViewModel} from './archived-view-model';
import {TypeUtils} from '../../../../../utils/type-utils';

@Component({
  selector: 'app-archived',
  templateUrl: './archived.component.html',
  styleUrls: ['./archived.component.scss'],
  providers: [ArchivedViewModel],
})
export class ArchivedComponent extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy, Tabbable {

  @Input() associatedInsiderId: string;
  types = TypeUtils;

  constructor(
    public vm: ArchivedViewModel,
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupViews();
  }

  setupViews() {
  }

  ngAfterViewInit(): void {
    this.setupBindings();
  }

  setupBindings() {
  }

  ngOnDestroy(): void {
    this.destroy();
  }

}
